var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7046,
    cy: 10.6206,
    rx: 10.7046,
    ry: 10.3885,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4091 10.6841C21.4091 4.91172 16.6165 0.232178 10.7046 0.232178C4.79264 0.232178 0 4.91163 0 10.6841C0 15.901 3.91453 20.2251 9.03198 21.0091V13.7054H6.31402V10.6841H9.03198V8.38144C9.03198 5.76192 10.6301 4.31497 13.0752 4.31497C14.2464 4.31497 15.4714 4.51911 15.4714 4.51911V7.09128H14.1217C12.7918 7.09128 12.3772 7.89697 12.3772 8.72358V10.6841H15.346L14.8714 13.7054H12.3772V21.0091C17.4946 20.2251 21.4091 15.9011 21.4091 10.6841Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.831e653fa788d26564b077b885d4bb3b.svg";
export { ForwardRef as ReactComponent };